<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="110" class="search-form">
                            <Form-item label="蓝海订单序列号" prop="orderSeqNo">
                                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入蓝海订单序列号" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
            <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
                <FormItem label="z_copyright_register_dci 的主键ID" prop="id" >
                <Input v-model="form.id" style="width:100%"/>
            </FormItem>
                <FormItem label="蓝海订单序列号" prop="orderSeqNo" >
                    <Input v-model="form.orderSeqNo" style="width:100%"/>
                </FormItem>
                <FormItem label="备注信息" prop="remarks" >
                    <Input v-model="form.remarks" style="width:100%"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="modalVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
            </div>
        </Modal>

        <Modal :title="modalTitle" v-model="infoFormVisible" :mask-closable='false' :width="640">
            <Form ref="infoForm" :model="infoForm" :label-width="100" >
                <FormItem label="作品全称" prop="orderTitle" >
                    <Input v-model="infoForm.workFullName" style="width:90%"/>
                </FormItem>
                <FormItem label="订单号" prop="orderSeqNo" >
                    <Input v-model="infoForm.orderSeqNo" style="width:90%"/>
                </FormItem>

                <FormItem label="作品类型" prop="workTypeDesc" >
                    <Input v-model="infoForm.workType" style="width:90%"/>
                </FormItem>
                <FormItem label="创作完成地点" >
                    <Input v-model="infoForm.completeCountry" style="width:30%"/>
                    <Input v-model="infoForm.completeProvince" style="width:30%"/>
                    <Input v-model="infoForm.completeCity" style="width:30%"/>
                </FormItem>
                <FormItem label="订单提交时间" prop="createDate" >
                    <Input v-model="infoForm.createDate" style="width:90%"/>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "blueOrder",
        components: {
        },
        data() {
            return {
                infoFormVisible: false,
                loading: true, // 表单加载状态
                modalType: 0, // 添加或编辑标识
                modalVisible: false, // 添加或编辑显示
                modalTitle: "", // 添加或编辑标题
                searchForm: { // 搜索框初始化对象
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "", // 默认排序字段
                    order: "desc", // 默认排序方式
                },
                form: { // 添加或编辑表单对象初始化数据
                    id: "",
                    orderSeqNo: "",
                    remarks: "",
                },
                // 表单验证规则
                formValidate: {
                },
                submitLoading: false, // 添加或编辑提交状态
                selectList: [], // 多选数据
                selectCount: 0, // 多选计数
                columns: [
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "",
                        key: "id",
                        minWidth: 150,
                        sortable: false,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                            icon: "ios-create-outline"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.getOrderInfo(params.row.id);
                                            }
                                        }
                                    },
                                    "查看版权登记订单信息"
                                )
                            ]);
                        }
                    },
                    {
                        title: "z_copyright_register_dci 的主键ID",
                        key: "id",
                        minWidth: 220,
                        sortable: false,
                    },
                    {
                        title: "蓝海订单序列号",
                        key: "orderSeqNo",
                        minWidth: 320,
                        sortable: false,
                    },
                    {
                        title: "订单发送到蓝海时间",
                        key: "createDate",
                        minWidth: 100,
                        sortable: false,
                    },
                    {
                        title: "备注信息",
                        key: "remarks",
                        minWidth: 120,
                        sortable: false,
                    }
                ],
                data: [], // 表单数据
                total: 0, // 表单数据总数
                infoForm: {},
            };
        },
        methods: {
            getOrderInfo(id){
                this.getRequest('/copyrightRegisterDci/getById/' + id).then(res => {
                    if(res.success){
                        this.infoForm = res.result;
                        this.infoFormVisible = true;
                    }
                })
            },
            init() {
                this.getDataList();
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                // 重新加载数据
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            changeSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            getDataList() {
                this.loading = true;
                // 带多条件搜索参数获取表单数据 请自行修改接口
                this.getRequest("/blue/order/getByPage", this.searchForm).then(res => {
                  this.loading = false;
                  if (res.success) {
                    this.data = res.result.records;
                    this.total = res.result.total;
                  }
                });
            },
            handleSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        if (this.modalType === 0) {
                            // 添加 避免编辑后传入id等数据 记得删除
                            delete this.form.id;
                            // this.postRequest("请求地址", this.form).then(res => {
                            //   this.submitLoading = false;
                            //   if (res.success) {
                            //     this.$Message.success("操作成功");
                            //     this.getDataList();
                            //     this.modalVisible = false;
                            //   }
                            // });
                            // 模拟请求成功
                            this.submitLoading = false;
                            this.$Message.success("操作成功");
                            this.getDataList();
                            this.modalVisible = false;
                        } else {
                            // 编辑
                            // this.postRequest("请求地址", this.form).then(res => {
                            //   this.submitLoading = false;
                            //   if (res.success) {
                            //     this.$Message.success("操作成功");
                            //     this.getDataList();
                            //     this.modalVisible = false;
                            //   }
                            // });
                            // 模拟请求成功
                            this.submitLoading = false;
                            this.$Message.success("操作成功");
                            this.getDataList();
                            this.modalVisible = false;
                        }
                    }
                });
            },
            add() {
                this.modalType = 0;
                this.modalTitle = "添加";
                this.$refs.form.resetFields();
                delete this.form.id;
                this.modalVisible = true;
            },
            edit(v) {
                this.modalType = 1;
                this.modalTitle = "编辑";
                this.$refs.form.resetFields();
                // 转换null为""
                for (let attr in v) {
                    if (v[attr] === null) {
                        v[attr] = "";
                    }
                }
                let str = JSON.stringify(v);
                let data = JSON.parse(str);
                this.form = data;
                this.modalVisible = true;
            }
        },
        mounted() {
            this.init();
        }
    };
</script>
<style lang="less">
    .search {
        .operation {
            margin-bottom: 2vh;
        }
        .select-count {
            font-size: 13px;
            font-weight: 600;
            color: #40a9ff;
        }
        .select-clear {
            margin-left: 10px;
        }
        .page {
            margin-top: 2vh;
        }
        .drop-down {
            font-size: 13px;
            margin-left: 5px;
        }
    }
</style>